import styles from './Photo.module.css';

export const Photo = ({ message, rotateSign }) => {
  return (
    <div
      style={{ transform: `rotate(${rotateSign}5deg)` }}
      className={styles.photo}
    >
      <img
        src={message?.attachments[0].url}
        alt="image"
        className={styles.attach}
      />
    </div>
  );
};
